import React from 'react';
import PropTypes from 'prop-types';
import { isSet } from '../../../utils/commonUtils';

const TextArea = (props) => {
  const {
    className,
    placeholder,
    value,
    style,
    disabled,
    readOnly,
    name,
    required,
    onKeyPress,
    onBlur,
    ref,
    rows,
    max,
  } = props;

  const { changeHandler } = props;

  const onChangeHandler = (e) => {
    let val = e.target.value;
    if (max) {
      const maxValue = parseInt(max, 10);
      val = val.slice(0, maxValue);
    }
    changeHandler(val, {e});
  };

  return (
    <textarea
      className={className}
      name={name}
      id={isSet(props.id,name)}
      placeholder={placeholder}
      value={value}
      style={{...style}}      
      disabled={disabled}
      readOnly={readOnly}
      onChange={(e) => onChangeHandler(e)}
      onKeyDown={onKeyPress}
      required={required}
      onBlur={onBlur}
      ref={ref}
      rows={rows}
      maxLength={max ? parseInt(max, 10) : undefined}
    />
  );
};

TextArea.defaultProps = {
  className: 'form-control',
  placeholder: '',
  disabled:false,
  readOnly:false,
  value: '',
  style: {},
  required:false,
  onBlur:()=>{},
  ref:null,
  rows:""
};

TextArea.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  changeHandler: PropTypes.func.isRequired,
};

export default TextArea;
